import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../services/AuthContext";
import { getAdminSession } from "../services/admin";
import { isAllowedAdmin } from "../config/admin";
import LoadingComponent from "../pages/loading_component/loading_component";

const AdminRoute = ({ children }) => {
  const { user, loading, getIdToken } = useAuth();
  const location = useLocation();
  const [sessionState, setSessionState] = useState("checking");

  useEffect(() => {
    let cancelled = false;

    const checkAdminSession = async () => {
      if (loading) return;
      if (!user) {
        setSessionState("unauthenticated");
        return;
      }

      try {
        const token = await getIdToken();
        if (!token) {
          if (!cancelled) setSessionState("unauthenticated");
          return;
        }
        if (!isAllowedAdmin(user, token)) {
          if (!cancelled) setSessionState("forbidden");
          return;
        }
        await getAdminSession(token);
        if (!cancelled) setSessionState("ok");
      } catch (error) {
        if (cancelled) return;
        if (error?.status === 401) {
          setSessionState("unauthenticated");
        } else {
          setSessionState("forbidden");
        }
      }
    };

    setSessionState("checking");
    checkAdminSession();

    return () => {
      cancelled = true;
    };
  }, [user, loading, getIdToken]);

  if (loading || sessionState === "checking") {
    return <LoadingComponent />;
  }

  if (!user || sessionState === "unauthenticated") {
    const redirectPath = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/logon?redirect=${redirectPath}`} replace />;
  }

  if (sessionState === "forbidden") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
